import { SearchableSelect } from "@/components/shared/SearchableSelect";

export function SiteFilterSelect({ sites, value, onChange, testId, placeholder = "Select site", allowAll = false }) {
  const options = [
    ...(allowAll ? [{ value: "all", label: "All Sites", pinned: true, testId: `${testId}-option-all` }] : []),
    ...sites.map((s) => ({ value: s.code, label: s.display_label || s.label, testId: `${testId}-option-${s.code}` })),
  ];
  return (
    <SearchableSelect
      testId={testId}
      className="w-56"
      value={value || (allowAll ? "all" : "")}
      onValueChange={(v) => onChange(v === "all" ? "" : v)}
      placeholder={placeholder}
      options={options}
    />
  );
}
